import { gql } from '../../common/functions/gql';

const productFragment = gql`
  fragment Product on ProductSearchVariant {
    id
    sku
    attributesRaw {
      name
      value
    }
    prices {
      value {
        currencyCode
        centAmount
        fractionDigits
      }
    }
    assets {
      sources {
        uri
      }
    }
  }
`;

export const PLP_QUERY = gql`
  query GetPLP(
    $queryFilters: [SearchFilterInput!]!
    $facets: [SearchFacetInput!]!
    $sort: [String!]!
    $limit: Int!
    $offset: Int!
    $searchText: String
  ) {
    productProjectionSearch(
      queryFilters: $queryFilters
      facets: $facets
      sorts: $sort
      limit: $limit
      offset: $offset
      staged: false
      locale: "en-US"
      text: $searchText
      fuzzy: true
      markMatchingVariants: true
    ) {
      total
      results {
        id
        key
        categories{
          id
          key
        }
        allVariants (onlyMatching:true) {
          ...Product
        }

      }
      facets {
        facet
        value {
          ... on TermsFacetResult {
            total
            terms {
              term
              productCount
            }
          }
        }
      }
    }
  }
  ${productFragment}
`;


export const AddressSearchFragment = gql`
  fragment AddressSearchFragment on Channel {
    id
    key
    nameAllLocales {
      value
    }
    address {
      streetName
      country
      state
      city
      region
      postalCode
    }
    geoLocation {
      ... on Point {
        coordinates
      }
    }
    custom {
      typeRef {
        id
      }
      customFieldsRaw {
        name
        value
      }
    }
  }
`;

export const FindChannelWithoutAddressQuery = gql`
query FindChannelWithoutAddressQuery($where: String) {
  channels(where:  $where, limit:500) {
    count
    results {
      ...AddressSearchFragment
    }
  }
}
${AddressSearchFragment}
`;

export const FindProductWithAddressQuery = `
  query FindProductWithAddressQuery($where: String) {
    channels(where:  $where ) {
      count
      results {
        ...AddressSearchFragment
      }
    }
  }
  ${AddressSearchFragment}
`;